import { connect, MapStateToProps } from "react-redux";

import { createGetColumnNumber, createGetGridTemplate, createGetRowNumber, getComponent, isComponentSelected } from "../selectors";
import { IPicassoState, ObjectType, WrapMapStateToProps } from "../types";
import { MoveableComponent, MoveableComponentProps } from "./MoveableComponent";

type MoveableProps = Pick<MoveableComponentProps, "index">;

type StateProps = Pick<MoveableComponentProps, "uiComponent" | "isSelected" | "gridTemplate" | "rowNumber" | "columnNumber">;

const createMapStateToProps = <S extends ObjectType>(wrapMapStateToProps: WrapMapStateToProps<S>) => () => {
    const getGridTemplate = createGetGridTemplate();
    const getRowNumber = createGetRowNumber();
    const getColumnNumber = createGetColumnNumber();

    const mapStateToProps: MapStateToProps<StateProps, MoveableProps, IPicassoState> = (state, { index }) => ({
        uiComponent: getComponent(state, index),
        isSelected: isComponentSelected(state, index),
        gridTemplate: getGridTemplate(state, index),
        rowNumber: getRowNumber(state, index),
        columnNumber: getColumnNumber(state, index),
    });

    return wrapMapStateToProps(mapStateToProps);
};

export const createMoveable = <S extends ObjectType>(wrapMapStateToProps: WrapMapStateToProps<S>) => connect(createMapStateToProps(wrapMapStateToProps))(MoveableComponent);
